// extracted by mini-css-extract-plugin
module.exports = {"root":"SHNFA","serviceCategories":"_2RBfG"};